// Module
var code = "<page-header model=\"ctrl.navModel\"></page-header>\n\n<div class=\"page-container page-body\">\n\n  <div class=\"grafana-info-box span8\">\n    Grafana is a multi-tenant system where most can be configured per organization. These\n    admin pages are for server admins where you can manage orgs, & all users across all orgs.\n  </div>\n\n</div>\n\n<footer>\n";
// Exports
var _module_exports =code;;
var path = 'public/app/features/admin/partials/admin_home.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;